import apiRequest from './index'

export default {
  path: '/v1/maintenance_pack/subscriptions',
  async get (authId) {
    await window.callNativeHTTPX()
    return apiRequest.get(`${this.path}?authid=${authId}`, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  }
}
